export default __webpack_public_path__ + "static/media/92.8f5c2fd2.png";